// Figures shown for a whole project (its card, its header, the map's centre).
import { TaskItem } from '../../types/tasks';
import { daysBetween } from '../../utils/taskDates';
import { isLate } from '../../utils/projectPlan';

/** Overall progress: the mean of the main branches, as each parent's is the mean of its children. */
export function projectProgress(items: TaskItem[]): number {
  const main = items.filter((i) => i.parent_id === null && !i.deleted_at);
  return main.length ? Math.round(main.reduce((sum, i) => sum + i.progress, 0) / main.length) : 0;
}

/** The next event or milestone still to come, and how far off it is. */
export function nextMarker(items: TaskItem[], today: string): { item: TaskItem; inDays: number } | null {
  const upcoming = items
    .filter((i) => (i.node_kind === 'event' || i.node_kind === 'milestone') && i.progress < 100 && i.plan_start && i.plan_finish! >= today)
    .sort((a, b) => a.plan_start!.localeCompare(b.plan_start!));
  if (!upcoming.length) return null;
  const first = upcoming[0];
  return { item: first, inDays: Math.max(0, daysBetween(today, first.plan_start!)) };
}

/** Unfinished tasks that can't be done in time as planned (sub-topics only, so a branch isn't counted twice). */
export function lateCount(items: TaskItem[]): number {
  const parents = new Set(items.map((i) => i.parent_id));
  return items.filter((i) => !parents.has(i.id) && isLate(i)).length;
}

export function inDaysLabel(n: number): string {
  return n === 0 ? 'today' : n === 1 ? 'tomorrow' : `in ${n} days`;
}
